export default __webpack_public_path__ + "static/media/character_red_02.4655b809.png";